import _ from "lodash";

export const STATUS = [1, 2, 3, 4];
export const STATE = [1, 2, 3, 4, 5];

export const MODULE_NAME = "quality_assurance_and_accreditation";

export const QUALITY_ASSURRANCE = "quality_assurance";
export const ACCREDITATION = "accreditation";

export const DETAIL_DRAFTED = 1;
export const DETAIL_FORM_DEPLOYED = 2;
export const DETAIL_DATA_COLLECTION_IN_PROGRESS = 3;
export const DETAIL_IN_REVIEW = 4;
export const DETAIL_CONFIRMED = 5;

export const PROJECT_UNACCREDITED = 1;
export const PROJECT_ACCREDITED = 2;
export const PROJECT_SUSPENDED = 3;
export const PROJECT_CANCELLED = 4;

export const DETAIL_TYPE_ACC = "acc";
export const DETAIL_TYPE_QA = "qa";

export const FORM_VALIDATED_REQ = "FORM_VALIDATED_REQ";
export const FORM_VALIDATED_RESP = "FORM_VALIDATED_RESP";
export const FORM_VALIDATED_ERR = "FORM_VALIDATED_ERR";
